<template>
    <div class="block--small text">
        <h3>Privacy voorwaarden</h3>
        <p>
            Lorem ipsum dolor sit amet, consectetur adipisicing elit. Amet cum cumque ipsum iusto magni nemo nesciunt odit quaerat quibusdam quod, saepe suscipit tempora tenetur unde voluptas. Consequatur dolore ducimus facere!
            <h4>Dit is een tussenkop</h4>
            Lorem ipsum dolor sit amet, consectetur adipisicing elit. Accusantium corporis excepturi possimus sunt. Consectetur dolore dolorum enim et facilis non, odio pariatur qui similique voluptatibus. Cupiditate ipsum numquam vitae voluptates.
            <br/><br/>
            Lorem ipsum dolor sit amet, consectetur adipisicing elit. Ad aliquam esse explicabo nobis pariatur qui quia tempora vitae voluptate. Laudantium provident vero voluptas? Accusamus dolorem inventore libero quasi qui, voluptate.
            <h4>Dit is een tussenkop</h4>
            Lorem ipsum dolor sit amet, consectetur adipisicing elit. A accusamus dolor, dolorum eveniet, ex excepturi facilis illum impedit libero molestiae nobis nulla officia omnis praesentium quos rem sapiente, velit voluptatem.
            <br/><br/>
        </p>
    </div>
</template>

<script>
    import Vue from 'vue';
    import Component from 'vue-class-component';
    import TheHeader from '@/components/general/TheHeader';
    import TheFooter from '@/components/general/TheFooter';
    import Sidebar from '@/components/general/Sidebar';

    @Component
    export default class PrivacyPolicy extends Vue {
        name = 'privacy-policy';
    }

    Vue.component(PrivacyPolicy.name, PrivacyPolicy);
</script>

<style lang="scss">
    .block--small {
        text-align: start;
    }
    
    h3 {
        text-align: center;
    }
</style>



// WEBPACK FOOTER //
// src/pages/PrivacyPolicy.vue